import React from "react";

const MapIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
      <circle cx="6" cy="6" r="1.5" fill="currentColor"></circle>
      <circle
        cx="6"
        cy="6"
        r="4.5"
        stroke="currentColor"
        strokeWidth="1"
      ></circle>
    </svg>
  );
};

export default MapIcon;
